import { Observable } from 'rxjs';
import { HeaderLogoDto } from '@data/data/models/header-logo.dto';

export abstract class HeaderRepository {
  abstract getHeaderLogo(): Observable<HeaderLogoDto[]>;
}
